import { iDocTagDataMap } from './docTag.type';

import { docTagEffects, docTagReducers } from './docTag.operator';

// DocTag 初始状态
export const docTagInitData: iDocTagDataMap = {};

// Model
export const docTagModel = {
  state: docTagInitData,
  effects: docTagEffects,
  reducers: docTagReducers,
};
